// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"7ce5d1b4","319":"82430ca6","439":"12e1bc9e","693":"f8cee0c3","845":"09a83532"}[chunkId] + ".chunk.js";
};